import React, { Component, cloneElement } from 'react';
import { List, CreateButton, Datagrid, TextField, DateField, ReferenceField, EditButton, DeleteButton, TopToolbar, RefreshButton, AutocompleteInput, Filter, ReferenceInput, SelectInput, NumberInput, TextInput, DateTimeInput } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
// import { DateTimeInput } from 'react-admin-date-inputs';
import { GetCurrentUserRoles, monthList, RUN_TIME_API_ENDPOINT, CommonHeaderOption, getCurrencySymbol } from '../common/common';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';

const ProbasePaymentsFilter = (props) => {
    const noOftargets = [...Array(3).keys()];
    console.log("LoyaltyPointsFilter prop===>", props);
    return (
        <Filter {...props}>
            <ReferenceInput 
            // label="Sold To Id" 
            source="sap_code" reference="businesses" linkType="show" allowEmpty>
                <AutocompleteInput optionText="sap_code" />
            </ReferenceInput>
            <ReferenceInput label="Retailer Name" source="business_id" reference="businesses" linkType="show" allowEmpty>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <DateTimeInput source="created_at" 
            // label="Created At" 
            />

            <TextInput source="payment_id" label="Payment ID" />
            <NumberInput source="amount" label="Amount" min={0} />
            <TextInput source="description" label="Payment Description" />
            <TextInput source="bank_reference" label="Bank Reference" />
            <TextInput source="payment_status" label="Payment Status" />
            <TextInput source="last_payment_error" label="Last Payment Error" />

        </Filter>
    )
}


const AmountField = ({ record = {}, source }) => {
    return (
        record[source] ? <span>{record['currency']} {record[source]}</span> : "-"
    )
}

class ListActions extends Component {
    constructor(props) {

        super(props);
        this.state = {
            modalShow: false,
            modalMsg: '',
            customFilterUrl: 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
        }
    }

    callExport = (e) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        console.log('...', window.location.href, `${apiUrl}/${this.props.resource}_csv`)
        options.method = 'GET';
        let _url = window.location.href.split('?');
        if (_url.length > 1 && _url[1] !== '') {
            console.log('params found');
            this.setState({ customFilterUrl: _url[1] }, () => {
                fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
                    .then(res => {
                        return res.json();
                    }).then(jsonD => {
                        console.log('json= inside callback', jsonD.data);
                        const msg = jsonD.data[0].message;
                        Swal.fire({
                            html: msg,
                            icon: 'success',
                        })
                    });
            })
        } else {
            this.setState({ customFilterUrl: 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D' }, () => {
                fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
                    .then(res => {
                        return res.json();
                    }).then(jsonD => {
                        console.log('json= inside callback', jsonD.data);
                        const msg = jsonD.data[0].message;
                        Swal.fire({
                            html: msg,
                            icon: 'success',
                        })
                    });
            })
        }
    }
    exporterModal = () => {
        return ''
    }

    onClose = () => {
        this.setState({ modalShow: false })
    }
    render() {
        const { resource, filterValues, total, basePath, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = this.props;
        const csvResource = resource + '_csv'
        return (
            <React.Fragment>
                <TopToolbar>
                    {filters && cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: 'button',
                    })}
                    <RefreshButton />
                    <div>
                        <button className="export-button"
                            onClick={(e) => this.callExport(e)}
                            disabled={total === 0}
                            sort={currentSort}
                            filter={{ ...filterValues, ...permanentFilter }}
                        >
                            {<GetAppIcon />}
                            <span>Export</span>
                        </button>
                    </div>
                </TopToolbar>
            </React.Fragment>
        )
    }
}

const FormattedCurrencyNumberCustom = (props) => {
    console.log('props inside FormattedCurrencyNumberCustom===>', props);
    // console.log('record inside FormattedCurrencyNumberCustom===>', record);
    const currPorps = props.record.amount;
    // const value = currPorps.value;
    const direction = currPorps.currencyDirection ? currPorps.currencyDirection : 'left';
    const thousandSep = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
      .format(currPorps);
    return (
      <span className="custom-formated-currency">
        { direction === 'right' &&
          <span>
            {thousandSep}
          </span>
        }
        { direction !== 'right' &&
          <span>
            {thousandSep}
          </span>
        }
      </span>
    );
  }

class ProbasePaymentsList extends Component {

    render() {
        const { props, permissions } = this;
        const noOftargets = [...Array(3).keys()];
        const curr = getCurrencySymbol();
        console.log('curr===>', curr);
        let roleData = GetCurrentUserRoles();
        let editBtn = false;
        if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
            editBtn = true
        }
        return (
            <React.Fragment>
                <Scrollbars class="scroll-container">
                    <List {...props} exporter={false} sort={{ field: 'created_at', order: 'DESC' }} filters={<ProbasePaymentsFilter />} undoable={false} title="Probase Payment List" bulkActionButtons={false} actions={<ListActions permissions={permissions} />}>
                        <Datagrid>
                            <DateField source="created_at" 
                            // label="Created At" 
                            showTime />
                            <ReferenceField label="Retailer Id " source="business_id" reference="businesses" link="show" allowEmpty>
                                <TextField source="sap_code" />
                            </ReferenceField>
                            <ReferenceField label="Retailer Name" source="business_id" reference="businesses" link="show" allowEmpty>
                                <TextField source="name" />
                            </ReferenceField>
                            <TextField source="payment_id" label="Payment ID" />
                            <FormattedCurrencyNumberCustom source="amount" label={`Amount(${curr})`} />
                            <TextField source="description" label="Payment Description" />
                            <TextField source="bank_reference" label="Bank Reference" />
                            <TextField source="payment_status" label="Payment Status" />
                            <TextField source="last_payment_error" label="Last Payment Error" />
                        </Datagrid>
                    </List>
                </Scrollbars>
            </React.Fragment>
        )
    }
}

export default ProbasePaymentsList;